import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ChildProtection from '../components/ChildProtection';

const FamillePage = () => {
  useEffect(() => {
    document.title = 'Famille — MonAlerte';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <ChildProtection />
      </main>
      <Footer />
    </>
  );
};

export default FamillePage;
